import { render, staticRenderFns } from "./WithdrawRecord.vue?vue&type=template&id=22ba657d&scoped=true"
import script from "./WithdrawRecord.vue?vue&type=script&lang=js"
export * from "./WithdrawRecord.vue?vue&type=script&lang=js"
import style0 from "./WithdrawRecord.vue?vue&type=style&index=0&id=22ba657d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba657d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ba657d')) {
      api.createRecord('22ba657d', component.options)
    } else {
      api.reload('22ba657d', component.options)
    }
    module.hot.accept("./WithdrawRecord.vue?vue&type=template&id=22ba657d&scoped=true", function () {
      api.rerender('22ba657d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/financials-agent/components/Balance/WithdrawRecord.vue"
export default component.exports